import { Component } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-demo-dialog',
  styleUrls: ['./demo-dialog.component.scss'],
  templateUrl: './demo-dialog.component.html',
})
export class DemoDialogComponent {
  constructor() {}
}
